module.exports = __webpack_public_path__ + "img/POE.17dc213e.svg";